import { render, staticRenderFns } from "./RightProjectInfo.vue?vue&type=template&id=316223d6&scoped=true&lang=pug"
import script from "./RightProjectInfo.vue?vue&type=script&lang=js"
export * from "./RightProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./RightProjectInfo.vue?vue&type=style&index=0&id=316223d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316223d6",
  null
  
)

export default component.exports